module.exports = __webpack_public_path__ + "img/kong.0160f215.png";